export default [
    {
        path: '/paquetes/eventoSigCod/:eventoSigCod',
        name: 'paquetes',
        component: () => import('@/modules/facturacion/paquetes/views/ListadoViews.vue'),
        meta: {
            slug: 'area-ver', // para los permisos
        },
    },
];